import React from 'react';
export function ProofBar() {
  return <div className="bg-gradient-to-br from-card-bg to-[rgba(107,0,182,0.3)] border-y border-[rgba(194,0,111,0.3)] py-3 md:py-4 px-5" data-id="element-246" data-mp="1r30ifd6mxseh">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5 text-center" data-id="element-247" data-mp="7l2c9i4arb86">
        <div className="flex flex-col items-center" data-id="element-248" data-mp="cjvrpg359caz">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-249" data-mp="cikll9m87sgp">
            40%
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-250" data-mp="3j7g0s183o19">
            Reducción de ansiedad Basado en protocolos de neurociencia cognitiva
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-251" data-mp="3ktp10utb2d62">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-252" data-mp="3prqgl5rivucs">
            4 Vol.
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-253" data-mp="1iyelk8itsm1q">
            Colección completa formato Digital PDF— El Camino a la Recuperación
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-254" data-mp="2sddrq0akgezy">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-255" data-mp="2ng55nomarqtf">
            21 días
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-256" data-mp="3248bmy0cb2i8">
            Prácticas diarias de minutos para reprogramar el ciclo
          </p>
        </div>
      </div>
    </div>;
}